import { useQuery } from '@tanstack/react-query';

import { REQUEST_STALE_TIME_IN_MS } from '@/constants';
import { klassAnalyticsQueries } from '@/data/query-keys/klassAnalyticsQueryKey';
import { KlassesPendingSummaryTotalFilters } from '@/data/services/klassAnalyticsServices';
import { useSingleCache } from './query/v2/useCacheManager';

const useKlassesPendingSummaryTotal = (
  filters: KlassesPendingSummaryTotalFilters = {},
) => {
  const pendingSummaryQueryKey =
    klassAnalyticsQueries.pendingSummaryTotal(filters);
  const { data: pendingCount, isInitialLoading: isLoading } = useQuery({
    ...pendingSummaryQueryKey,
    staleTime: REQUEST_STALE_TIME_IN_MS,
  });

  const cache = useSingleCache(pendingSummaryQueryKey.queryKey);

  return {
    pendingSummaryQueryKey,
    pendingCount,
    isLoading,
    cache,
  };
};

export default useKlassesPendingSummaryTotal;
